import { useIntl } from "react-intl";
import { StudyLevelModel } from "../../../../types/indicators.interfaces";
import { getStudyCategoryDictionary } from "../../../../helpers/dictionaries.helper";
import {
  XAxisLabel,
  HorizontalBar,
  BarGraph,
  BarGroup,
  YAxisLabelStudyLevel,
  YAxis,
  XAxisStudyLevel,
  BarValue,
} from "../zonePopulation.styles";

export const StudyLevelGraph = (props: StudyLevelModel) => {
  const intl = useIntl();
  const categoryLabels = getStudyCategoryDictionary(intl);
  const ranges = Object.values(props.categories ?? {}).map((value) => value);
  const maxPercentage = Math.max(...ranges.map((range) => range ?? 0));

  return (
    <BarGraph>
      <XAxisStudyLevel>
        {generatePercentageProgression(maxPercentage).map((label, index) => (
          <XAxisLabel key={index}>{label}%</XAxisLabel>
        ))}
      </XAxisStudyLevel>
      <YAxis>
        {Object.entries(props.categories ?? {}).map((item, index) => (
          <YAxisLabelStudyLevel key={index}>
            <div style={{ width: "15%", whiteSpace: "nowrap" }}>
              {categoryLabels[item[0] as keyof typeof categoryLabels]}
            </div>
            <BarGroup>
              <HorizontalBar
                width={`${(Number(item[1]) / (maxPercentage + 10)) * 100}%`}
                backgroundcolor="#B85959"
              />
              <BarValue>{Number(item[1]).toFixed(1)}%</BarValue>
            </BarGroup>
          </YAxisLabelStudyLevel>
        ))}
      </YAxis>
    </BarGraph>
  );
};

// Generate X-axis labels as percentages up to the maximum percentage found
function generatePercentageProgression(maxPercentage: number) {
  const steps = 4;
  const interval = (maxPercentage + 10) / steps;

  const progression = [];
  for (let i = 0; i <= steps; i++) {
    progression.push(Math.ceil(interval * i));
  }

  return progression;
}
